import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('collections-carousel')) {
    class CollectionsCarousel extends HTMLElement {
        connectedCallback() {
            this.elSection = this.closest('section');
            this.elContainer = this.elSection?.querySelector('.carousel-section--header');
            this.elNext = this.elSection.querySelector('[data-navigation="next"]');
            this.elPrev = this.elSection.querySelector('[data-navigation="prev"]');
            this.enabled = this.getAttribute('enabled') === 'true';

            this.initCarousel();
        }

        disconnectedCallback() {
            window.removeEventListener('resize', this.#handleResize);
        }

        #getContainerOffset() {
            return this.elContainer?.getBoundingClientRect().left ?? 12;
        }

        #handleResize = () => {
            if (!this.swiper || !window.matchMedia('(min-width: 1920px)').matches) return;

            const offset = this.#getContainerOffset();
            this.swiper.params.slidesOffsetBefore = offset;
            this.swiper.params.slidesOffsetAfter = offset;
            this.swiper.update();
        };

        async initCarousel() {
            const Swiper = await loadSwiper();
            const containerOffset = this.#getContainerOffset();
            this.swiper = new Swiper(this, {
                enabled: this.enabled,
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 12,
                slidesOffsetAfter: 12,
                navigation: {
                    nextEl: this.elNext,
                    prevEl: this.elPrev,
                },
                breakpoints: {
                    768: {
                        spaceBetween: 10,
                    },
                    1920: {
                        slidesOffsetBefore: containerOffset,
                        slidesOffsetAfter: containerOffset,
                    },
                },
            });

            window.addEventListener('resize', this.#handleResize);

            this.setAttribute('data-swiper-ready', '');
        }
    }

    customElements.define('collections-carousel', CollectionsCarousel);
}
